import Swiper from "./vendor-script-swiper.min.js"

class ProductGallery extends HTMLElement {
	constructor() {
		super()
		this.previewGalleryElement = this.querySelector(".product-gallery_preview")
		this.thumbsGalleryElement = this.querySelector(".product-gallery_thumbs")
		this.galleryPaginationElement = this.querySelector(".product-gallery_pagination")
		this.galleryButtonPrev = this.querySelector(".product-gallery_button-prev")
		this.galleryButtonNext = this.querySelector(".product-gallery_button-next")
		this.productOptionsDisplayType = document.querySelector(".product-options_options-info-label")?.innerText.toUpperCase()

		this.initGalleryThumbs()
		this.initGallery()
		this.showNavigation()
		this.initListeners()
	}

	initListeners() {
		window.addEventListener("product-gallery-update", () => {
			this.galleryUpdate()
		})
	}

	initGalleryThumbs() {
		this.thumbsGallery = new Swiper(this.thumbsGalleryElement, {
			spaceBetween: 16,
			slidesPerView: 5,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true
		})
	}

	initGallery() {
		this.mainGallery = new Swiper(this.previewGalleryElement, {
			initialSlide: this.getInitialSlide(),
			thumbs: {
				swiper: this.thumbsGallery
			},
			pagination: {
				el: this.galleryPaginationElement
			},
			navigation: {
				nextEl: this.galleryButtonNext,
				prevEl: this.galleryButtonPrev
			}
		})
	}

	getInitialSlide() {
		let initialSlide = 0
		const searchQuery = window.location.search

		if (searchQuery && this.productOptionsDisplayType && this.productOptionsDisplayType === "FINISH") {
			const productVariant = new URLSearchParams(searchQuery.substring(searchQuery.indexOf("?"))).get("variant")
			const slides = this.previewGalleryElement.querySelectorAll(".product-gallery_preview-slide")

			slides.forEach((slide, i) => {
				if (slide.hasAttribute("data-slide-id")) {
					const slideIds = slide.getAttribute("data-slide-id").split(",");
					if (slideIds.includes(productVariant.toString())) {
						initialSlide = i
					}
				}
			})
		}

		return initialSlide
	}

	galleryUpdate() {
		const searchQuery = window.location.search

		if (searchQuery && this.productOptionsDisplayType === "FINISH") {
			const productVariant = new URLSearchParams(searchQuery.substring(searchQuery.indexOf("?"))).get("variant")
			const slides = this.mainGallery.slides

			slides.forEach((slide, i) => {
				if (slide.hasAttribute("data-slide-id")) {
					const slideIds = slide.getAttribute("data-slide-id").split(",");
					if (slideIds.includes(productVariant.toString())) {
						this.mainGallery.slideTo(i, 1000);
					}
				}
			})
		}
	}

	showNavigation() {
		const slidesCount = this.mainGallery.slides.length

		if (slidesCount > 5) {
			this.galleryButtonPrev.classList.add("show")
			this.galleryButtonNext.classList.add("show")
		}
	}
}

customElements.define("product-gallery", ProductGallery)
